// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  COMMON_COST_PROCESSING_CSV,
} from './constants';

let processCost=(tableData)=>{
  let returnTable={}
  let headers=[]
  let summary=[]
  let indexes=[]
  let fixedData=[]
  //checking  the cost type
  if(tableData.type===1){
    let newTableData=tableData.data.map(row=>{
      let newValue=row
      newValue[tableData.headers[0].key]=tableData.lookupTable[newValue.type-1]
      return newValue
    })
    returnTable={
      headers:tableData.headers,
      data:newTableData, 
      tableName:tableData.tableName, 
      disabled:true
    }
  }else{
    //preparing data
    for (let indice = 0; indice < tableData.data.length; indice++) {
      const element = tableData.data[indice];
      if(element.description!==undefined){
        let tmp={
          description:element.description, 
          cost_catalog:element.cost_catalog
        }
        summary.push(tmp)
        indexes.push(element.cost_catalog)
      }
    }
    // fixing the data
    fixedData=tableData.data.splice(indexes.length,tableData.data.length)
    fixedData.sort((a, b) => (a.cost_catalog > b.cost_catalog));
    // checking the cost type in order to extract their specific data
    if(tableData.type===2){
      fixedData=fixedData.map(row=>{
        if(row.cost_catalog===undefined){
          let newRow={
            resource:"Total", wp:"-", dj:"-",hr:"-",sd:"-",ed:"-",dc:"-",nd:row.number_days,tc:row.total_cost
          }
          return newRow
        }else{
          let newRow={
            resource:summary[indexes.indexOf(row.cost_catalog)].description, 
            wp:row.w_name, dj:row.journey,hr:row.hourly_rate,sd:row.start_date,ed:row.finish_date, dc:row.daily_cost,nd:row.number_days,tc:row.total_cost
          }
          return newRow
        }
      })
      //configuring the table headers
      headers=[ 
        {label:"Resource", key:"resource"},{label:"Work Package",key:"wp"},{label:"Daily Journey", key:"dj"},{label:"Hourly Rate", key:"hr"},
        {label:"Start Date", key:"sd"},{label:"End Date", key:"ed"},{label:"Daily Cost", key:"dc"},
        {label:"Number Of Days", key:"nd"},{label:"Total Cost", key:"tc"}
      ]
    }else if(tableData.type===3){
      fixedData=fixedData.map(row=>{
        if(row.cost_catalog===undefined){
          let newRow={ 
            resource:"Total", wp:"-", ut:"-",qt:"-",up:"-",sd:"-",ed:"-",nd:row.number_days,tc:row.total_cost
          }
          return newRow
        }else{
          let newRow={
            resource:summary[indexes.indexOf(row.cost_catalog)].description, 
            wp:row.w_name, ut:row.unit_name,qt:row.quantity, 
            up:row.price,sd:row.start_date,ed:row.finish_date,
            nd:row.number_days,tc:row.total_cost
          }
          return newRow
        }
      })      
      //configure the headears
      headers=[
        {label:"Resource", key:"resource"},{label:"Work Package",key:"wp"},{label:"Unit", key:"ut"},
        {label:"Quantity", key:"qt"},{label:"Unit Price", key:"up"},{label:"Start Date", key:"sd"},
        {label:"End Date", key:"ed"},{label:"Number Of Days", key:"nd"},{label:"Total Cost", key:"tc"}
      ]
    }else if(tableData.type===4){
      fixedData=fixedData.map(row=>{
        if(row.cost_catalog===undefined){
          let newRow={
            resource:"total", wp:"-", up:"-",sd:"-",ed:"-",tc1:"-",nd:row.number_days,tc:row.total_cost
          }
          return newRow
        }else{
          let newRow={
            resource:summary[indexes.indexOf(row.cost_catalog)].description, 
            wp:row.w_name, up:row.price,sd:row.start_date,
            ed:row.finish_date,tc1:row.period_type===1?"Start":row.period_type===2?"End":"Weighted",nd:row.number_days,tc:row.total_cost
          }
          return newRow
        }
      })
      //configure the headears
      headers=[
        {label:"Resource", key:"resource"},{label:"Work Package",key:"wp"},{label:"Unit Price", key:"up"},
        {label:"Start Date", key:"sd"},{label:"End Date", key:"ed"},{label:"Type Of Cost", key:"tc1"},
        {label:"Number Of Days", key:"nd"},{label:"Total Cost", key:"tc"}
      ]
    }else if(tableData.type===5){
      fixedData=fixedData.map(row=>{
        if(row.cost_catalog===undefined){
          let newRow={
            resource:"Total", wp:"-", up:"-",sd:"-",ed:"-",tc1:"-",nd:row.number_days,tc:row.total_cost
          }
          return newRow
        }else{
          let newRow={
            resource:summary[indexes.indexOf(row.cost_catalog)].description, 
            wp:row.w_name, ut:row.unit_name,qt:row.quantity,price:row.price,
            sd:row.start_date,ed:row.finish_date, nd:row.number_days,
            dc:row.daily_cost,tc:row.total_cost
          }
          return newRow
        }
      })
      //configure the headears
      headers=[
        {label:"Resource", key:"resource"},{label:"Work Package",key:"wp"},{label:"Unit", key:"ut"},
        {label:"Quantity", key:"qt"},{label:"Price", key:"price"},{label:"Start Date", key:"sd"},
        {label:"End Date", key:"ed"},{label:"Number of Days", key:"nd"},{label:"Dailty Cost", key:"dc"},{label:"Total Cost", key:"tc"}
      ]
    }
    // configuring the return table 
    returnTable={
      headers:headers,
      data:fixedData, 
      tableName:tableData.tableName,
      disabled:true
    }
  }

  return returnTable;
}


export function costProcessingCsv(tableData) {
  let csvTableData = processCost(tableData)
  return {
    type: COMMON_COST_PROCESSING_CSV,
    data:csvTableData
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_COST_PROCESSING_CSV:
      return {
        ...state,
        csvTableData:action.data
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/costProcessingCsv.js